import { Link } from "react-router-dom";
import { ArrowRight, GraduationCap, Package, Store } from "lucide-react";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@/components/ui/carousel";
import SectionHeader from "@/components/SectionHeader";
import { useShops } from "@/hooks/useCatalog";
import { fileUrl } from "@/lib/api";

export default function FeaturedShops() {
  const { data: shops = [], isLoading } = useShops();
  if (isLoading || !shops.length) return null;

  const showControls = shops.length > 3;

  return (
    <section className="container-it pt-14 lg:pt-20" data-testid="home-shops">
      <SectionHeader
        title="Boutiques vedettes"
        subtitle="Nos revendeurs"
        linkTo="/boutiques"
        linkLabel="Voir toutes les boutiques"
        testId="home-shops-title"
      />
      <Carousel opts={{ align: "start", loop: showControls }} className="mt-2">
        <CarouselContent className="-ml-4">
          {shops.map((shop) => (
            <CarouselItem key={shop.shop_slug} className="pl-4 sm:basis-1/2 lg:basis-1/3">
              <Link
                to={`/boutique-vendeur/${shop.shop_slug}`}
                data-testid={`shop-card-${shop.shop_slug}`}
                className="group flex h-full flex-col rounded-2xl border border-line bg-white p-5 shadow-[0_8px_30px_rgba(0,0,0,0.04)] transition-[transform,box-shadow] duration-300 hover:-translate-y-1 hover:shadow-[0_20px_40px_rgba(0,0,0,0.09)]"
              >
                <div className="flex items-center gap-3">
                  <span className="flex h-14 w-14 shrink-0 items-center justify-center overflow-hidden rounded-xl bg-brand-soft text-brand">
                    {shop.shop_logo ? (
                      <img src={fileUrl(shop.shop_logo)} alt={shop.shop_name} className="h-full w-full object-cover" />
                    ) : (
                      <Store className="h-6 w-6" />
                    )}
                  </span>
                  <div className="min-w-0">
                    <h3 className="truncate font-display text-base font-extrabold text-ink transition-colors duration-200 group-hover:text-brand">
                      {shop.shop_name}
                    </h3>
                    {shop.country && <p className="truncate text-xs text-slate-400">{shop.country}</p>}
                  </div>
                </div>

                <p className="mt-3 line-clamp-2 flex-1 text-sm leading-relaxed text-slate-500">
                  {shop.shop_description || "Boutique partenaire ISMO-TECH."}
                </p>

                <div className="mt-4 flex items-center gap-4 text-xs font-bold text-slate-600">
                  <span className="flex items-center gap-1.5">
                    <Package className="h-3.5 w-3.5 text-brand" /> {shop.products} produits
                  </span>
                  <span className="flex items-center gap-1.5">
                    <GraduationCap className="h-3.5 w-3.5 text-brand" /> {shop.formations} formations
                  </span>
                </div>

                <span className="mt-4 flex items-center gap-1.5 text-sm font-bold text-brand">
                  Visiter la boutique
                  <ArrowRight className="h-4 w-4 transition-transform duration-200 group-hover:translate-x-1" />
                </span>
              </Link>
            </CarouselItem>
          ))}
        </CarouselContent>
        {showControls && (
          <>
            <CarouselPrevious data-testid="shops-prev" className="hidden lg:flex" />
            <CarouselNext data-testid="shops-next" className="hidden lg:flex" />
          </>
        )}
      </Carousel>
    </section>
  );
}
